<template>
  <div @mousedown.self="handleMouseDown" class="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md">
    <Transition name="fadeTable">
      <div v-if="open" class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl p-6 md:p-8 relative overflow-y-auto max-h-[90vh] flex flex-col gap-4">
        <div class="flex justify-between items-center border-b pb-4 ">
          <div class="flex items-center gap-4">
            <!-- <button @click="loading = !loading">Loading</button> -->
            <component :is="'PresentationChartBarIcon'" :style="{color: '#3b82f6'}" class="h-14 w-14 mt-1" />
            <div class="flex flex-col whitespace-nowrap">
              <h2 class="text-2xl font-bold text-gray-800">Nowe zestawienie</h2>
              <p class="text-sm text-gray-500">Wybierz datę, aby wygenerować plik CSV</p>
            </div>
          </div>
          <div v-if="!loading" class="flex items-center gap-2">
            <button @click="$emit('close')" aria-label="Zamknij" class="p-2 rounded-full bg-gray-100 border border-gray-200 hover:bg-gray-200 transition">
              <XIcon class="h-6 w-6 text-gray-600" />
            </button>
            <button :disabled="!checkIfDateRangeIsPicked()" @click.prevent="generateSummary()" aria-label="Zapisz zmiany" :class="[!checkIfDateRangeIsPicked() ? 'opacity-50 cursor-not-allowed' :' cursor-pointer']" class="p-2 rounded-full bg-blue-100 border border-blue-200 hover:bg-blue-200 transition">
              <CheckIcon class="h-6 w-6 text-blue-600" />
            </button>
          </div>
        </div>
        <div v-if="!loading">
          <!-- <button @click="getBacklogsOfSegment">TEST BUTTON</button> -->
          <div class="text-sm text-gray-900 font-medium mb-1">Dane z okresu</div>
          <VueDatePicker
            v-model="selectedDate"
            :min-date="minDate"
            :max-date="maxDate"
            range
            auto-apply
            
            :enable-time-picker="false"
            :teleport="true"
            @update:model-value="onDateChange"
            :format="format"
            locale="pl"
            cancelText="Anuluj"
            selectText="Wybierz"
            placeholder="Wybierz datę"
          />
        </div>
        <div v-else>
          <!-- <SkeletonTheme color="#f0f0f0" highlightColor="#e0e0e0">
            <Skeleton class="h-24 w-full mb-4" />
          </SkeletonTheme> -->
          <LoadingSpinnerHub class="w-full mb-4" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { PresentationChartBarIcon,CheckIcon, XIcon } from '@heroicons/vue/outline'
import { Skeleton, SkeletonTheme } from 'vue-loading-skeleton';
import "vue-loading-skeleton/dist/style.css"
import axios from 'axios';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import {db} from "@/firebase/gfbconf.js";
import LoadingSpinnerHub from './LoadingSpinnerHub.vue';

export default {
  name: 'ModalToCopy',
  components: { 
    VueDatePicker,
    Skeleton, SkeletonTheme,
    PresentationChartBarIcon,CheckIcon, XIcon,
    LoadingSpinnerHub
    // PencilSquareIcon, TrashIcon, CheckIcon, ChevronDownIcon, UserPlusIcon, XMarkIcon 
  },
  props: {
    visible: { type: Boolean, required: true },
  },
  data() {
    return {
      selectedDate: null,
      minDate: new Date(2025, 0, 1, 0, 0, 0, 0),
      // maxDate yesterday 23:59:59
      maxDate: (() => {
        const now = new Date();
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        yesterday.setHours(23, 59, 59, 999);
        return yesterday;
      })(),
      open: false,
      loading: false,
    }
  },
  computed: {
},
  methods: {
    async getBacklogsOfSegment() {
      this.loading = true;

      if (!Array.isArray(this.selectedDate) || this.selectedDate.length !== 2) {
        console.warn("Zakres dat nie został wybrany.");
        this.loading = false;
        return;
      }

      const [startDate, endDate] = this.selectedDate;

      const startUnix = Math.floor(startDate.getTime() / 1000);
      const endUnix = Math.floor(endDate.getTime() / 1000);

      const baseQuery = db.collection("StorageBacklogs")
        .where("meta.created.unix", ">=", startUnix)
        .where("meta.created.unix", "<=", endUnix);

      let receivedQuery = baseQuery.where("part.status", "in", [1, 3]);
      const releasedQuery = baseQuery.where("part.status", "in", [2]);
      const deletedQuery  = baseQuery.where("part.status", "==", 5);
      receivedQuery = receivedQuery.where("location.segment.name", "==", "11B");
      try {
        let receivedList = [];
        let releasedList = [];
        let deletedList = [];

        let totalReceivedQuantity = 0;
        let totalReleasedQuantity = 0;
        let totalDeletedQuantity  = 0;
        let difference = 0;
        let differenceWithDeleted = 0;

        const [receivedSnap, releasedSnap, deletedSnap] = await Promise.all([
          receivedQuery.get(),
          releasedQuery.get(),
          deletedQuery.get()
        ]);

        receivedList = receivedSnap.docs.map(doc => doc.data());
        releasedList = releasedSnap.docs.map(doc => doc.data());
        deletedList  = deletedSnap.docs.map(doc => doc.data());

        totalReceivedQuantity = receivedList.reduce((sum, item) => sum + (item.part?.quantity || 0), 0);
        totalReleasedQuantity = releasedList.reduce((sum, item) => sum + (item.part?.quantity || 0), 0);
        totalDeletedQuantity  = deletedList.reduce((sum, item) => sum + (item.part?.quantity || 0), 0);

        difference = totalReceivedQuantity - totalReleasedQuantity;
        differenceWithDeleted = totalReceivedQuantity - (totalReleasedQuantity + totalDeletedQuantity);

        console.log(receivedList)
        // 🔍 logi
            let summaryData = {
              received: totalReceivedQuantity,
              released: totalReleasedQuantity,
              deleted: totalDeletedQuantity,
              difference: difference,
              differenceWithDeleted: differenceWithDeleted
            };
            this.loading = false;
        return summaryData;
      } catch (err) {
        console.error("❌ Błąd podczas pobierania danych:", err);
        alert("Wystąpił błąd podczas pobierania danych. Spróbuj ponownie później.");
        this.loading = false;
      }

      // this.loading = false;
    },
    async getAllBacklogs() {
      this.loading = true;

      if (!Array.isArray(this.selectedDate) || this.selectedDate.length !== 2) {
        console.warn("Zakres dat nie został wybrany.");
        this.$store.commit('setNotification',{
          show: true,
          head: "Zakres dat nie został wybrany!",
          subheader: `Proszę wybrać zakres dat przed wygenerowaniem podsumowania.`,
          success: false
        });
        this.loading = false;
        return null;
      }

      const [startDate, endDate] = this.selectedDate;
      const startUnix = Math.floor(startDate.getTime() / 1000);
      const endUnix = Math.floor(endDate.getTime() / 1000);

      try {
        const response = await axios.post(`${this.$store.state.apiLink}/storage/adminSummary`, {
          startUnix,
          endUnix
        });

        if (response.data.success) {
          const summaryData = response.data.data;

          console.log("📦 Podsumowanie:", summaryData);
          this.loading = false;
          return summaryData;
        } else {
          console.error("❌ Błąd logiki:", response.data.log);
          alert("Błąd: " + response.data.log);
          this.loading = false;
          return null;
        }

      } catch (error) {
        console.error("❌ Błąd żądania:", error);
        alert("Wystąpił błąd podczas wysyłania zapytania.");
        this.loading = false;
        return null;
      }
    },
    async generateSummary(){
      if(!this.$store?.state?.userData?.permissions?.admin){return;}
      let data = await this.getAllBacklogs();

      console.log(data)
      if(data.received === 0 && data.released === 0 && data.deleted === 0) {
        this.$store.commit('setNotification',{
          show: true,
          head: "Brak danych do wygenerowania pliku!",
          subheader: `Nie znaleziono żadnych zdarzeń w wybranym dniu.`,
          success: false
        });
        return;
      }else{
        this.generateCSV(data)
      }
    },
    generateCSV(data){
      const listHeaderLine = {
        date: 'Data',
        received: 'Przyjęte',
        released: 'Wydane',
        deleted: 'Usunięte',
        difference: 'Różnica',
        differenceWithDeleted: 'Różnica z usuniętymi',
      }
      const dataLine = {
        date: this.format(this.selectedDate),
        received: data.received,
        released: data.released,
        deleted: data.deleted,
        difference: data.difference,
        differenceWithDeleted: data.differenceWithDeleted
      }
      const csvContent = [
        listHeaderLine,
        dataLine
      ]
      const csvdata = this.csvmaker(csvContent);
      this.download(csvdata, ('magazyn_admin_csv_'+this.format(this.selectedDate)));
        this.$store.commit('setNotification',{
            show: true,
            head: "Pomyślnie wygenerowano podsumowanie zamówień!",
            subheader: `Pobrano plik CSV.`,
            success: true
        });
    },
    csvmaker(data)
    {
      let csvRows = [];
      for(let i=0;i<data.length; i++)
      {
        const values = Object.values(data[i]).join(';');
        csvRows.push(values)
      }
      return csvRows.join('\n')
    },
    download(data, fileName)
    {
      const blob = new Blob(["\ufeff", data], { type: 'text/csv;charset=utf-8'});
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url);
      a.setAttribute('download', `${fileName}`+`.csv`);
      a.click()
    },
    checkIfDateRangeIsPicked() {
      // Check if selectedDate is an array with two dates
      return Array.isArray(this.selectedDate) && this.selectedDate.length === 2;
    },
    selectedDatesAsUnix(dates){
      //use moment.js to format dates to unix timestamp
      if (Array.isArray(dates) && dates.length === 2) {
        const startDate = moment(dates[0]).startOf('day').unix();
        const endDate = moment(dates[1]).endOf('day').unix();
        return [startDate, endDate];
      } else if (dates) {
        return moment(dates).unix();
      }
      return null;
    },
    getNextFullHour() {
      return firstDayOf2025 = new Date(2025, 0, 1, 0, 0, 0, 0);
    },
    format(dates) {
      if (Array.isArray(dates) && dates.length === 2) {
        const formatDate = (date) => {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}.${month}.${year}`;
        };

        return `${formatDate(dates[0])} - ${formatDate(dates[1])}`;
      }

      return '';
    },
    onDateChange(dates) {
      if (Array.isArray(dates) && dates.length === 2) {
        const startDate = new Date(dates[0]);
        const endDate = new Date(dates[1]);

        // Ustawienie czasu na 00:00:00 dla daty początkowej
        startDate.setHours(0, 0, 0, 0);

        // Ustawienie czasu na 23:59:59 dla daty końcowej
        endDate.setHours(23, 59, 59, 999);

        // Można teraz np. zapisać do modelu lub wysłać dalej:
        this.selectedDate = [startDate, endDate];
      } else {
        // Jeśli to nie range, np. pojedyncza data
        this.selectedDate = dates;
      }
    },
    handleMouseDown(e) {
      if (e.button === 0) { // 0 = left mouse button
        if( this.loading) return;
        this.$emit('close');
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.open = this.visible
    }, 100)
  }
}
</script>

<style scoped>
.fadeTable-enter-active, .fadeTable-leave-active {
  transition: transform 0.2s, opacity 0.5s, height 0.5s ease;
}

.fadeTable-enter-from, .fadeTable-leave-to {
  transform: scale(0);
  opacity: 0;
  height: 0;
}

.fadeTable-enter, .fadeTable-leave-to {
  display: none;
}
</style>
